import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCameraAuto"><Path d="M12 12.4447L12.6972 14H11.3028L12 12.4447Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.96482 6L8.96482 3H15.0352L17.0352 6H22V21H2V6H6.96482ZM10.9041 10L7.83749 16.8409C7.81407 16.8932 7.7955 16.9464 7.78159 17H9.95794L10.4062 16H13.5938L14.042 17H16.2184C16.2045 16.9464 16.1859 16.8932 16.1625 16.8409L13.0959 10H10.9041Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraAuto;
